import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/system";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import imageCompression from "browser-image-compression";
import { baseUrl } from "../Baseurl";
import axiosInstance from "../Redux/Features/Slices/AxiosInstance";

export const nameSplit = (data) => {
  const dataPart = data.split(" ");
  return dataPart;
};

// Aadhaar/PAN return gender as a raw "M"/"F" code, but Gender <select> fields
// only have "Male"/"Female"/"Other" options — without this mapping the value
// silently doesn't match any <option> and the field looks unselected even
// though it was auto-filled.
export const normalizeGenderCode = (value) => {
  if (value === "M") return "Male";
  if (value === "F") return "Female";
  return value || "";
};

export const splitData = (data, key) => {
  if (data == null) return [];
  return String(data).split(key);
};

export const formatDate1 = (dateStr) => {
  if (!dateStr) return "-"; // agar null/undefined/empty ho

  const date = new Date(dateStr);

  if (isNaN(date.getTime())) return "-"; // agar invalid date ho

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getDefaultPassword = (firstName) => {
  if (!firstName) return "Default@123";
  const formattedName =
    firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
  return `${formattedName}@123`;
};

export const owlCrouselOptions = {
  items: 1,
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  nav: false,
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 1,
    },
    1024: {
      items: 1,
    },
  },
};

export const getActiveData = (data) =>
  data && data.filter((item) => item.active === true);

// Zipcode for Branch/GetBranchListOfDistrictByZipAndBank:
// secured segment (leadsegment 1) -> property city pin, otherwise lead pincode.
export const isSecuredLeadSegment = (leadSegment) => Number(leadSegment) === 1;

export const getBranchLookupZipCode = ({ leadSegment, propertyCityPin, pincode }) =>
  (isSecuredLeadSegment(leadSegment) ? propertyCityPin : pincode) || "";

export const getValueLabel = (data, key) => {
  if (data && Array.isArray(data)) {
    return data
      .map((val) => {
        const rawLabel = val[key] || "";
        const capitalizedLabel =
          rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1).toLowerCase();

        return {
          value: val.id,
          label: capitalizedLabel,
        };
      })
      .sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        return labelA.localeCompare(labelB);
      });
  } else {
    console.error("Invalid data provided");
    return [];
  }
};

export const checkFloat = (inputValue) => {
  if (Number.isInteger(parseFloat(inputValue))) {
    return "int";
  } else {
    return "float";
  }
};

export const calculateTotalAmount = (details) => {
  let totalAmount = 0;
  details.forEach((detail) => {
    let amount = parseFloat(detail.amount);
    if (!isNaN(amount)) {
      totalAmount += amount;
    }
  });
  return totalAmount;
};
export const YearformatDate = (date) => {
  if (!date) return "-";

  // Aadhaar/PAN KYC APIs return DOB as "DD-MM-YYYY", which the native
  // Date constructor misreads as "MM-DD-YYYY" and rejects (e.g. "14-09-1967"
  // has no month 14), so handle that shape explicitly before falling back.
  let d;
  const ddmmyyyyMatch =
    typeof date === "string" && date.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (ddmmyyyyMatch) {
    const [, day, month, year] = ddmmyyyyMatch;
    d = new Date(`${year}-${month}-${day}`);
  } else {
    d = new Date(date);
  }
  if (isNaN(d)) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

export const hasDuplicateEmail = (data, otherEmail, emailKey) => {
  const seenEmails = new Set();

  for (let i = 0; i < data.length; i++) {
    if (seenEmails.has(data[i][emailKey])) {
      return true;
    }
    seenEmails.add(data[i][emailKey]);
  }

  if (data.some((item) => item[emailKey] === otherEmail)) {
    return true;
  }

  return false;
};

export const hasDuplicateMonileNo = (
  data,
  contect,
  otherNumber,
  whatsAppNo,
  numberKey
) => {
  const seenMobiles = new Set();
  for (let i = 0; i < data.length; i++) {
    if (seenMobiles.has(data[i][numberKey])) {
      return true;
    }
    seenMobiles.add(data[i][numberKey]);
  }

  if (data.some((item) => item[numberKey] === otherNumber)) {
    return true;
  }

  if (data.some((item) => item[numberKey] === whatsAppNo)) {
    return true;
  }

  if (data.some((item) => item[numberKey] === contect)) {
    return true;
  }

  return false;
};

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiAutocomplete-inputRoot": {
    padding: "0 !important",
    margin: "0 !important",
    height: "50px",
    background: "none",
    border: "1px solid #32438E",
  },
  "& .MuiInputBase-root": {
    height: "50px",
    background: "#f4f4f4",
    borderRadius: "3px",
    marginTop: "8px",
  },
  "& .MuiInputBase-input": {
    boxShadow: "none !important",
    outline: "none !important",
  },
}));

// Chrome ignores autoComplete="off"/"new-password" on MUI Autocomplete inputs
// and keeps showing saved form history (keyed by the input's name/id). A
// random name never matches saved history, and an unknown autoComplete token
// stops address autofill. Usage: inputProps={noBrowserSuggestInputProps(params.inputProps)}
export const noBrowserSuggestInputProps = (inputProps) => ({
  ...inputProps,
  name: `nosuggest-${Math.random().toString(36).slice(2)}`,
  autoComplete: "nosuggest",
});

// Formatting the date
export const formatDate = (isoDateString) => {
  if (
    !isoDateString ||
    isoDateString === "01/01/1753 00:00:00" ||
    isoDateString === "0001-01-01T00:00:00" ||
    new Date(isoDateString).toString() === "Invalid Date"
  ) {
    return "-";
  }

  const date = new Date(isoDateString);
  if (isNaN(date.getTime())) return "-"; // Return "-" if the date is invalid

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// For today's Date
export const getTodayDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0"); // Pad single digit days with leading zero
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = today.getFullYear();

  return `${day}-${month}-${year}`;
};
export const capitalizeWords = (str) => {
  const words = str && str.split(" ");
  const capitalizedWords =
    words && words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalizedWords && capitalizedWords.join(" ");
};

export const getfromDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}-01`;
};

export const getToDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const humanReadableHeaders = (header) => {
  return header
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/_/g, " ") // Replace underscores with space
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
};

// utils.js
export const handleNumericInput = (e, setter) => {
  const newValue = e.target.value;
  if (/^\d*$/.test(newValue)) {
    setter(newValue);
  }
};

// utils/inputUtils.js
export const handleAmountInput = (e, setter) => {
  const newValue = e.target.value;

  // Allow only numbers, dot (for decimal), and commas (for formatting)
  if (/^[\d.-]*$/.test(newValue)) {
    setter(newValue);
  }
};
export const isImage = (filePath) => {
  if (!filePath) return false;

  const imageExtensions = [".jpg", ".jfif", ".jpeg", ".png", ".gif", ".bmp"];

  // Query string (?X-Amz-Expires=...) hata do check karne se pehle —
  // presigned S3 URLs me actual extension usse pehle hota hai
  const pathWithoutQuery = filePath.split("?")[0].toLowerCase();

  return imageExtensions.some((ext) => pathWithoutQuery.endsWith(ext));
};
export const getDateRange = () => {
  const currentDate = new Date();
  const endDate = formatDate(currentDate); // Current date in 'MM/DD/YYYY' format

  // Set the current date to the 1st day of the current month
  currentDate.setDate(1);
  const startDate = formatDate(currentDate); // Start date (1st day of the current month)

  return `${startDate} to ${endDate}`;
};

export const formatDateTime = (value) => {
  if (value === null) {
    return "-";
  }

  const formattedDate = new Date(value);

  const day = formattedDate.getDate().toString().padStart(2, "0");
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const year = formattedDate.getFullYear().toString().slice(2);
  const hours = formattedDate.getHours() % 12 || 12;
  const minutes = formattedDate.getMinutes().toString().padStart(2, "0");
  const ampm = formattedDate.getHours() >= 12 ? "PM" : "AM";

  return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
};

export const getFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // getMonth() is 0-indexed
  if (month >= 4) {
    // April or after
    return `${year}-${(year + 1).toString().slice(-2)}`;
  } else {
    // Jan to March
    return `${year - 1}-${year.toString().slice(-2)}`;
  }
};

export function formatDateTimeLocal(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

export const camelCaseToHumanReadable = (str) => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, str[0].toUpperCase());
};

export const handleInterviewResponse = async ({
  interviewId,
  interviewerId = localStorage.getItem("ID") || 0,
  fetchAllData,
}) => {
  const result = await Swal.fire({
    title: "Would you kindly confirm if you accept the interview?",
    icon: "question",
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: "Accept",
    denyButtonText: "Reject",
    cancelButtonText: "Cancel",
  });

  const postStatus = async (status, reason = "") => {
    Swal.fire({
      text:
        status === 1 ? "Submitting acceptance..." : "Submitting rejection...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const formData = new FormData();
      formData.append("InterviewId", interviewId);
      formData.append("Status", status);
      formData.append("InterviewerId", interviewerId);
      formData.append("Reason", reason);

      const response = await axiosInstance.post(
        `${baseUrl}ManageInterviewScheduling/UpdateInterviewScheduleStatusByInterviewer`,
        formData,
        {
          headers: {
            Accept: "*/*",
          },
        }
      );

      Swal.close();

      const data = response.data;
      if (data.success) {
        toast.success(data.message);
        return { success: true };
      } else {
        toast.error(data.message || "Something went wrong.");
        return { success: false };
      }
    } catch (err) {
      Swal.close();
      console.error(err);
      toast.error(
        status === 1
          ? "Failed to accept interview"
          : "Failed to reject interview"
      );
      return { success: false };
    }
  };

  if (result.isConfirmed) {
    return await postStatus(1); // Accept
  } else if (result.isDenied) {
    const { value: reason } = await Swal.fire({
      title: "Reason for rejection",
      input: "text",
      inputLabel: "Please enter the reason for rejection:",
      inputPlaceholder: "Enter reason here...",
      inputAttributes: { "aria-label": "Rejection reason" },
      showCancelButton: true,
      confirmButtonText: "Submit",
    });

    if (reason) {
      return await postStatus(0, reason); // Reject
    } else {
      toast.info("Rejection reason is required");
      return { success: false };
    }
  }

  // If cancelled
  return { success: false };
};

export const getLabel = (value) => {
  if (value === 1) return "ACCEPTED";
  if (value === 0) return "REJECTED";
  if (value === true) return "ACTIVE";
  if (value === false) return "DEACTIVE";

  return "PENDING";
};

export const getBadgeStyle = (label) => {
  switch (label) {
    case "ACCEPTED":
      return { bg: "green", color: "white" };
    case "REJECTED":
      return { bg: "#dc3545", color: "white" };
    case "ACTIVE":
      return { bg: "green", color: "white" }; // green
    case "DEACTIVE":
      return { bg: "#dc3545", color: "white" }; // red

    case "PENDING":
    default:
      return { bg: "#6c757d", color: "white" };
  }
};

export const getImageSrc = (data) => {
  if (!data) return "";

  // If already a data URI (base64 with prefix)
  if (data.startsWith("data:image")) {
    return data;
  }

  // Backend now returns the full URL; blob: previews also pass through as-is
  return data;
};

// Feedback

export const handleTechncialfeedback = async (feedbackFromData) => {
  const { feedback, leadId, grade, leadStageId } = feedbackFromData;

  if (!feedback) {
    toast.error("Feedback is required");
    return { success: false };
  }

  const formData = new FormData();
  formData.append("LeadId", leadId);
  formData.append("Id", "0");
  formData.append("CallStatus", "0");
  formData.append("Call_Recording_PathURL", "");
  formData.append("CallStartTime", "");
  formData.append("CallEndTime", "");
  formData.append("CallDuration", "");
  formData.append("Call_Reminder", "");
  formData.append("ReminderStatus", "0");
  formData.append("MoveToCommon", "0");
  formData.append("Lead_Percent", "0");
  formData.append("LeadStage_Status", leadStageId);
  formData.append("EmployeeId", localStorage.getItem("ID") || 0);
  formData.append("FeedBack_Related_To_Call", "");
  formData.append("FeedBack_Related_To_Lead", `${grade}-${feedback}`);

  try {
    const response = await axiosInstance.post(
      `${baseUrl}LeadDetail/WorkOnLead`,
      formData,
      {
        headers: {
          accept: "text/plain",
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const result = response.data;

    if (result.success) {
      toast.success(result.message);
      return { success: true };
    } else {
      toast.error(`Error: ${result.message || "Something went wrong"}`);
      return { success: false };
    }
  } catch (error) {
    console.error("API call error:", error);
    toast.error("Failed to Add Feedback");
    return { success: false };
  }
};

export const calculateAge = (dateString) => {
  if (!dateString) return "";
  const birthDate = new Date(dateString);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const toCapital = (text) => {
  if (!text) return "";
  return text.toString().toUpperCase();
};

export const ColumnHeaderWithInfo = ({
  title,
  info,
  iconSize = 14,
  placement = "top",
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "5px",
      }}
    >
      <span>{title}</span>

      {info && (
        <Tooltip
          title={info}
          placement={placement}
          arrow
        >
          <InfoOutlinedIcon
            style={{
              fontSize: iconSize,
              cursor: "pointer",
              color: "#6c757d",
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};

export const compressFile = async (file) => {
  try {

    // PDF ko compress nahi karna
    if (file.type === "application/pdf") {
      return file;
    }

    const options = {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 1200,
      useWebWorker: true,
    };

    const compressedFile = await imageCompression(
      file,
      options
    );

    return compressedFile;

  } catch (error) {

    console.log("Compression Error:", error);

    return file;
  }
};


export const getAge = (dob) => {
  if (!dob) return "-";

  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();

  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return `${age} Years`;
};


export const formatMonthYear = (value) => {
  if (!value) return "-";

  const [month, year] = value.split("-");

  const date = new Date(Number(year), Number(month) - 1);

  return date.toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
};

// True when the logged-in user is the one who picked this lead up from LEH —
// they can neither re-upload it to LEH nor take it back.
export const isPickedUpByMe = (row) => {
  const myId = Number(localStorage.getItem("ID"));
  const pickedBy = Number(row?.pickedUpEmployeeId);
  return !!myId && !!pickedBy && myId === pickedBy;
};

// True when the logged-in user is the lead's main picked DSA — when a DSA
// Associate picks a lead up, it's picked under their manager, so this can be
// the user even when pickedUpEmployeeId isn't.
const isMainPickedDsa = (row) => {
  const myId = Number(localStorage.getItem("ID"));
  const mainPicked = Number(row?.mainPickedDsaId);
  return !!myId && !!mainPicked && myId === mainPicked;
};

// Shared by every LEH list (Interested/Doable/LoggedIn/Sanction/UnderReview)
// to decide whether the "Take Back From LEH" action is available for a row.
// Never available to the employee who picked the lead up, nor to its main
// picked DSA.
// moveToCommon "YES" = still sitting in LEH, unpicked — always takeable back.
// moveToCommon "NO" = someone already picked it up — still takeable back, but
// only within `maxDays` of that pickup (pickedupDate), after which it's final.
export const canTakeBackFromLEH = (row, maxDays = 30) => {
  if (!row) return false;

  if (isPickedUpByMe(row) || isMainPickedDsa(row)) return false;

  if (row.moveToCommon === "YES") return true;

  if (row.moveToCommon === "NO") {
    if (!row.pickedupDate) return false;
    const pickedDate = new Date(row.pickedupDate);
    if (isNaN(pickedDate.getTime())) return false;

    const diffDays = (Date.now() - pickedDate.getTime()) / (1000 * 60 * 60 * 24);
    return diffDays <= maxDays;
  }

  return false;
};

// Why the "Take Back From LEH" icon is disabled (when canTakeBackFromLEH is
// false): `tooltip` shows on hover, `label` is the icon's titleAccess.
export const getLehTakeBackDisabledReason = (row) => {
  if (isPickedUpByMe(row) || isMainPickedDsa(row)) {
    return {
      tooltip: "⚪ Disabled — you picked up this lead from Loan Exchange Hub, so you can't take it back",
      label: "Picked-up employee can't perform this action",
    };
  }
  if (row?.moveToCommon === "NO") {
    return {
      tooltip: "⚪ Disabled — take-back window (30 days from pickup) has expired",
      label: "Take-back window (30 days from pickup) has expired",
    };
  }
  return {
    tooltip: "⚪ Disabled — not currently in Loan Exchange Hub",
    label: "Not available",
  };
};

// Display state of the "Upload to LEH" icon, shared by every LEH list
// (Interested/Doable/LoggedIn/Sanction/UnderReview). `tooltip` explains on
// hover why it's disabled; `label` is the icon's titleAccess.
export const getLehUploadIconState = (row) => {
  if (isPickedUpByMe(row)) {
    return {
      disabled: true,
      tooltip: "⚪ Disabled — you picked up this lead from Loan Exchange Hub, so you can't upload it again",
      label: "Picked-up employee can't perform this action",
      className: "action-icon--disabled",
    };
  }
  if (row?.moveToCommon === "YES") {
    return {
      disabled: true,
      tooltip: "🟠 Disabled — already in Loan Exchange Hub, waiting to be picked up",
      label: "Already in Loan Exchange Hub — waiting to be picked",
      className: "action-icon--warn",
    };
  }
  if (row?.moveToCommon === "NO") {
    return {
      disabled: true,
      tooltip: "🟢 Disabled — already picked up from Loan Exchange Hub",
      label: "Already picked up from Loan Exchange Hub",
      className: "action-icon--success",
    };
  }
  // paymentstatus from GetLeadStageListForManager: 0 = no successful payment
  // yet, 1 = paid. Unpaid leads are flagged red and blocked up front.
  if (row?.paymentstatus != null && Number(row.paymentstatus) === 0) {
    return {
      disabled: true,
      tooltip: "🔴 Disabled — payment pending, at least one successful payment is required to upload this lead to Loan Exchange Hub",
      label: "Payment pending — upload to Loan Exchange Hub needs a successful payment",
      className: "action-icon--danger",
    };
  }
  return {
    disabled: false,
    tooltip: "Upload this lead to the Loan Exchange Hub",
    label: "Upload to Loan Exchange Hub",
    className: "",
  };
};

